export var TOOLTIP_CONTENT_CLASSNAME = 'tooltip-button__content';
export var ANIMATION_DURATION_IN_MS = 300;